export default "__VITE_ASSET__gBrl92VO__";